import { Component, OnInit } from '@angular/core';
import { SuperNet } from '../shared/models/supernet';
import { SuperNetService } from '../shared/services/supernet.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
import { ErrorDto } from '../shared/models/error-dto';
@Component({
  selector: 'app-administrar-supernet',
  templateUrl: './administrar-supernet.component.html',
  styleUrls: ['./administrar-supernet.component.css']
})
export class AdministrarSupernetComponent implements OnInit {

  parametros: SuperNet = new SuperNet();
  supernets: SuperNet[];
  mensajeAlerta: string;
  errorDto: ErrorDto = new ErrorDto();
  constructor(private superNetService: SuperNetService, private adminIpService: AdministradorIpService) { }

  ngOnInit() {
    this.listarSuperNets();
  }
  listarSuperNets(): void {
    this.superNetService.listarSuperNet().subscribe(
      resultadoSuperNet => { this.supernets = resultadoSuperNet }
    );

  }
  validarRangosSuperNet(idSupernet: number) {
    swal({
      title: "Procesando",
      text: "espere un momento",
      icon: "warning",
      dangerMode: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      buttons: {
      }
    } as any)

    this.adminIpService.validarRangoSupernet(idSupernet).subscribe(

      resultado => {
        this.parametros = resultado;
        swal("Se creo correctamente", "Se validaron correctamente los rangos", "success").then(function () {
          // Redirect the user
          window.location.href = "/#/solicitar-ip";
        });
      }, error => {
        this.errorDto = error.error;
        this.mensajeAlerta = this.errorDto.mensajeError;
        swal("Se presento un error", "" + this.mensajeAlerta, "error").then(function () {
          // Redirect the user
          window.location.reload();
        })
      }
    );

  }
}



// WEBPACK FOOTER //
// ./src/app/administrar-supernet/administrar-supernet.component.ts